export default {
  product: {
    "BindProductToScreen.036581-0": "Ошибка генерации изображения",
    "PreView.474740-0": "Идет генерация изображения, пожалуйста, подождите",
    "PreView.474740-1": "Сбой генерации изображения",
  },
  menu: {
    retail_client_management: "Управление розничными клиентами",
    template_list: "Список шаблонов",
    picture_library: "Библиотека изображений",
    mobile_api_management: "Управление мобильными API",
    open_api_management: "Управление открытыми API",
    dashboard: "Панель мониторинга",
    system_setting: "Настройки системы",
    authorization_level: "Уровень авторизации",
    approval_flowchart: "Схема процесса согласования",
    product_information: "Информация о товарах",
    retail_main_data: "Основные данные розницы",
    outlet: "Торговая точка",
    product: "Товар",
    user_management: "Управление пользователями",
    user: "Пользователь",
    device_management: "Управление устройствами",
    gateway: "Шлюз",
    screens: "Электронные ценники",
    price_management: "Управление ценами",
    price_change_events: "События изменения цен",
    approval: "Согласование",
    approval_list: "Список согласований",
    approval_log: "Журнал согласований",
    system_records: "Системные записи",
    synchronized_logs: "Журналы синхронизации",
    view_company: "Данные компании",
    about: "О системе",
    view_profile: "Личный кабинет",
    logout: "Выйти",
    english: "Английский",
    chinese: "Китайский",
    indonesian: "Индонезийский",
    thai: "Тайский",
    armenian: "Армянский",
    russian: "Русский",
    language: "Язык",
    arabic: "Арабский",
    back_to_login: "Вернуться ко входу",
    online: "Онлайн",
    offline: "Офлайн",
    search_site: "Поиск точки",
    hide_secretkey: "Скрыть секретный ключ",
    show_secretkey: "Показать секретный ключ",
  },
};
